/* eslint-disable no-alert, no-console */
export default {
    namespaced: true,
    state: {
        error : {
            id : '',
            code : '',
            title : '',
            message: '',
            button: {
                text: 'トップに戻る',
                path: {name: 'top'},
            },
            canBack: true,
        }
    },
    getters: {
        error(state) {
            return state.error ?? 999
        },
        title(state) {
            return state.error.title ?? 'エラー'
        },
        message(state) {
            return state.error.message ?? 'システムエラーが発生しました'
        },
        errorCode(state) {
            return (state.error.id ?? 999) + '-' + (state.error.code ?? 999)
        },
        buttonText(state) {
            return state.error.button.text ?? 'トップに戻る'
        },
        buttonPath(state) {
            return state.error.button.path ?? {name: 'top'}
        },
        canBack(state) {
            return state.error.canBack
        }
    },
    mutations: {
        setError(state, payload) {
            state.error = payload
        }
    },
    actions: {
        setError({ commit }, error) {
            commit('setError', error)
        },
        clearError({ commit }) {
            const error = {
                id: null,
                code: null,
                title: null,
                message: null,
                button: {
                    text: null,
                    path: null,
                },
                canBack: true,
            }
            commit('setError', error)
        }
    },
}
